/* global responsiveVoice */
import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';

export default class VoiceSettings extends Component {

	constructor(props) {
		super(props);
		this.phrases = [];
		this.state = {
			useDefaultSettings:
				(CommonFunctions.getSetting(
				'useDefaultVoiceSettings', '1') === '1')
		};
	}

	checkVoice() {
		if (this.state.useDefaultSettings) {
			responsiveVoice.speak(this.checkPhrase.value);
			return;
		}
		responsiveVoice.speak(
				this.checkPhrase.value,
				this.voice.value,
				{
					rate: this.voiceRate.value,
					pitch: this.voicePitch.value,
					volume: this.voiceVolume.value
				});
	}

	saveSettings() {
		CommonFunctions.saveSetting('useDefaultVoiceSettings',
				this.state.useDefaultSettings ? '1' : '0');
		CommonFunctions.saveSetting(
				'checkPhrase', this.checkPhrase.value);

		if (!this.state.useDefaultSettings) {
			CommonFunctions.saveSetting(
					'voice', this.voice.value);
			CommonFunctions.saveSetting(
					'voiceRate', this.voiceRate.value);
			CommonFunctions.saveSetting(
					'voicePitch', this.voicePitch.value);
			CommonFunctions.saveSetting(
					'voiceVolume', this.voiceVolume.value);
		}

		this.props.app.setState({ mode: 'mainPanel' });
	}

	render() {

		return (
			<div>
				<div style={{ fontSize: 'xx-large' }}>Voice settings</div>

				<div style={{
						marginTop: 60,
						padding: 10,
						textAlign: 'left'}}>

					<div style={{ marginBottom: 10 }}>
						<input
							id="use-default-settings"
							type="checkbox"
							defaultChecked={this.state.useDefaultSettings }
							onClick={event => {
									this.setState({
											useDefaultSettings:
											event.target.checked});
								}} />
						<label htmlFor="use-default-settings"
						       style={{ marginLeft: 4 }}>
							Use default settings
						</label>
					</div>

					{ (!this.state.useDefaultSettings) && (
	<div>
		<table cellSpacing="10">
			<tbody>
				<tr>
					<td>Voice:</td>
					<td>
						<select
							ref={(r) => { this.voice = r; }}
							defaultValue={CommonFunctions.getSetting(
									'voice', 'UK English Female')}>
							{ CommonFunctions.createSelectOptions(
							responsiveVoice.getVoices().map(v => v.name)) }
						</select>
					</td>
				</tr>
				<tr>
					<td>Rate:</td>
					<td>
						<input
							ref={(r) => { this.voiceRate = r; }}
							type="number"
							min="0"
							max="1.5"
							step="0.1"
							defaultValue={CommonFunctions.getSetting(
								'voiceRate', '1')} />
					</td>
				</tr>
				<tr>
					<td>Pitch:</td>
					<td>
						<input
							ref={(r) => { this.voicePitch = r; }}
							type="number"
							min="0"
							max="2"
							step="0.1"
							defaultValue={CommonFunctions.getSetting(
								'voicePitch', '1')} />
					</td>
				</tr>
				<tr>
					<td>Volume:</td>
					<td>
						<input
							ref={(r) => { this.voiceVolume = r; }}
							type="number"
							min="0"
							max="1"
							step="0.1"
							defaultValue={CommonFunctions.getSetting(
								'voiceVolume', '1')} />
					</td>
					<td>
						<button onClick={() => {
								this.voice.value = 'UK English Female';
								this.voiceRate.value = 1;
								this.voicePitch.value = 1;
								this.voiceVolume.value = 1;
							}}>
							Reset
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
					)}

					<div>
						<table cellSpacing="10">
							<tbody>
								<tr>
									<td>Check phrase:</td>
									<td>
										<textarea
											cols="40"
											ref={(r) => {
												this.checkPhrase = r; }}
											defaultValue={
												CommonFunctions.getSetting(
												'checkPhrase',
												'What is your name?')} />
									</td>
									<td>
										<button onClick={() => {
												this.checkVoice(); }}>
											Check
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

				</div>

				<div style={{
						textAlign: 'right',
						position: 'absolute',
						bottom: 10,
						width: '90%' }}>

					<button onClick={() => { this.saveSettings(); }}>
						Save
					</button>

					<button
							style={{ marginLeft: 5 }}
							onClick={() => {
								this.props.app.setState({ mode: 'mainPanel' });
							}}>
						Close
					</button>

				</div>
			</div> );
	}
} // class VoiceSettingsPanel



// WEBPACK FOOTER //
// ./src/VoiceSettings.js